// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"498ebbe8","228":"f29d37c4","609":"9d7c5408","621":"791b40a1","856":"0f45db8e","952":"b9953f8a"}[chunkId] + ".chunk.css";
};